export default __webpack_public_path__ + "static/media/switchgreen.9dd7c58c.svg";